import Template from '../../component/Template.js';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Api from '../../component/Api.js';
import { Link } from 'react-router-dom';
import React, { useRef } from "react";
import Select from 'react-select';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';


export default function Vendorlist() {





  const tableRef = useRef(null);


  {/*------------------------------------*/ }
  /* CUSTOM DATA TABLE BEGIN HERE */

  const [tableData, setTableData] = useState([]);

  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [total_count, setTotal] = useState(null);
  const [reload, setReload] = useState(false);


  const [isDeleteUser, setDeleteUser] = useState(false);
  const [deleteUserID, setDeleteUserID] = useState(false);
  const [forwardUserID, setforwardUserID] = useState(false);
  const [show, setShow] = useState(false);
  const [selectedcollege, setSelectedcollege] = useState(false);
  const [selecteddiscipline, setSelectediscipline] = useState(false);
  const [collegeOptions, setCollegeOptions] = useState([]);
  const [disciplineOptions, setdisciplineOptions] = useState([]);
  const [Data, setData] = useState([]);


  /* CUSTOM DATA TABLE END HERE */


  const { http } = Api();
  const navigate = useNavigate();

  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/ino/");
  }

  useEffect(() => {


    const getCollegeUsersList = async () => {

      try {
        const response = await http.post(`/College/listTopic`);

        //console.log("res", response.data.data);
        setTableData(response.data.data);

      }
      catch (error) {

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/ino/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };


    getCollegeUsersList();


  }, [reload]);


  /* DATA TABLE  */

  const handleSearchInputChange = (event) => {

    setSearchQuery(event.target.value);
  };

  const handleSort = (column) => {

    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };


  useEffect(() => {
    const filteredAndSortedData = [...tableData].filter(tableDatas => {
      return (
        (tableDatas.offered_by_name ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.internship_topic ?? '').toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.mode_of_study ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase()) ||
        (tableDatas.status ?? '').toString().toLowerCase().includes(searchQuery.toLowerCase())

      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });

    const itemsPerPage = 50;
    const startIndex = (currentPage - 1) * itemsPerPage;
    const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

    setfilteredAndSortedData(paginatedData);
    setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
    setTotal(filteredAndSortedData.length);

  }, [searchQuery, sortBy, tableData, currentPage]);

  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };



  const handleGeneratePDFNew = async () => {
    // setLoading(true);
    try {
      const response = await http.get('/College/topicListpdfDownload', {
        responseType: 'blob', // Expect binary response
      });

      if (response && response.data) {
        // Create a URL for the downloaded file
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;

        // Set the file name and download the PDF
        link.setAttribute(
          'download',
          `Internship Topic.pdf`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // setLoading(false);
        toast.success('PDF generated successfully');
      }
    } catch (error) {
      //console.log("error",error);
      // setLoading(false);
      if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
        toast.error("Invalid Token");
        setTimeout(() => {
          navigate("/college/");
        }, 5000);

      }
      else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR47") {
        toast.error(error.response.data.message);
      }
      else {
        console.error('Error generating PDF:', error);
        toast.error('Error generating PDF');
      }
    }
  };


  const handleDeleteUser = (userid) => {
    setDeleteUserID(userid);
    setDeleteUser(true);
  }
  const handleDeleteCancel = () => {
    setDeleteUser(false);
  }

  const handleForwardUser = (userid) => {

    setforwardUserID(userid);
  }

  const handleedit = (userid) => {

    navigate(`/ino/editinternshiptopic/${userid}`);

  }
  const handleForwardCancel = () => {

    setforwardUserID(false);
  }


  const handleDeleteSuccess = async () => {
    http
      .post('/College/deleteTopic', {

        id: deleteUserID,

      })
      .then((response) => {

        if (response.data.status_code === "MSG3") {

          setDeleteUser(false);
          sessionStorage.setItem("message", "User deleted successfully");
          toast.success("Topic deleted successfully");
          setReload(!reload);

        }
      })
      .catch((error) => {

        toast.error("Something went wrong");
      });
  };

  const handleforwardSuccess = async () => {
    http
      .post('/College/forwardTopic', {

        id: forwardUserID,

      })
      .then((response) => {

        if (response.data.status_code === "MSG3") {

          setforwardUserID(false);
          toast.success("Topic forwarded successfully");
          setReload(!reload);

        }
      })
      .catch((error) => {

        toast.error("Something went wrong");

      });
  };

  const handleexplore = () => {

    setShow(true);

    http.get(`/College/ExploreCollege`)
      .then(response => {

        //console.log(response.data);
        setCollegeOptions(response.data.data);


      }).catch(error => {
        if (error.response.data.status_code === 'ERR9') {
          toast.error("Invalid token");
          setTimeout(() => {
            navigate('/');
          }, 5000);
        }
        else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
          toast.error("Data not found");

        }
        else {

          // console.error("Error in explore colleges for options:", error);
          toast.error("Something went wrong: ");
        }
      });
  }

  const handleCollegeChange = (selectedOption) => {

    setSelectedcollege(selectedOption);
    setSelectediscipline(false);
  };

  useEffect(() => {

    if (selectedcollege) {

      http.get(`College/ExploreDiscipline`, {
        params: {
          college_id: selectedcollege?.value,
        }
      })

        .then(response => {

          setdisciplineOptions(response.data.data);

        }).catch(error => {
          if (error.response.data.status_code === 'ERR9') {
            toast.error("Invalid token");
            setTimeout(() => {
              navigate('/');
            }, 5000);
          }
          else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
            toast.error("Data not found");

          }
          else {

            // console.error("Error in explore college diciplines:", error);
            toast.error("Something went wrong: ");
          }
        })
    }

  }, [selectedcollege])

  const handleDisiplinechange = (selectedOption) => {


    setSelectediscipline(selectedOption);

    if (!selectedcollege?.value || !selectedOption?.value) return;

    http.get(`College/ExploreMore`, {
      params: {
        college_id: selectedcollege.value,
        discipline_id: selectedOption.value,
      }
    }).then(response => {

      setData(response.data.data);


    }).catch(error => {
      if (error.response.data.status_code === 'ERR9') {
        toast.error("Invalid token");
        setTimeout(() => {
          navigate('/');
        }, 5000);
      }
      else if (error.response.data.http_status === 500 || error.response.data.status_code === 'ERR5') {
        toast.error("Data not found");

      }
      else {
        toast.error("Something went wrong: ");
      }
    })

  }




  const handleClose = () => {

    setShow(false);

  };



  return (
    <>
      <ToastContainer />
      <Template>
        <div className="container-fluid">
          <div className="row">
            <div className="table-responsive">
              <div className="card">
                <div className="col-md-12">
                  <div className="card-header">
                    <div className="py-3 d-flex justify-content-between align-items-center">
                      <h5>Internship Topic</h5>
                    </div>
                  </div>
                  <div className="card-body">


                    <div className="table-responsive">

                      <div className="row align-items-center pdg18">
                        {/* Left 6 columns */}
                        <div className="col-md-8">

                        </div>

                        {/* Right 6 columns */}
                        <div className="col-md-4 d-flex justify-content-end">
                          <div className="d-flex gap-2">

                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleexplore()}
                              title="Explore More"
                            >
                              <i className="bi bi-search ctm-btn-sz m-r-5"></i> Explore
                            </button>


                            <Link
                              className="btn custom-btn btn-primary common-btn d-inline-flex align-items-center justify-content-center"
                              to="/ino/Addinternshiptopic"
                              title="Add New Topic"
                            >
                              <i className="bi bi-plus-square ctm-btn-sz m-r-5"></i>New
                            </Link>



                            <button
                              className="btn btn-primary common-btn d-inline-flex align-items-center justify-content-center pdf-btn"
                              onClick={() => handleGeneratePDFNew()}
                              title="Download to PDF"
                            >
                              <i className="bi bi-arrow-down-square ctm-btn-sz"></i>
                            </button>

                          </div>
                        </div>
                      </div>

                      <div className='row'>

                        <div className='col-md-6 wdt' >
                          <p>
                            Showing {(currentPage - 1) * 50 + 1}{''}-
                            {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                          </p>
                        </div>
                        <div className='col-md-6 wdt' align='right'>
                          <input
                            type="text"
                            value={searchQuery}
                            onChange={handleSearchInputChange}
                            placeholder="Search..."
                            className='form-control'
                          /></div></div>
                      <div class="table-containerq" style={{ overflowX: 'unset' }}>

                        <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>
                          <thead>
                            <tr className="bg-primary">
                              <th onClick={() => handleSort('id')} scope="col" data-label="APAAR Id" width="8%">
                                Sl No &nbsp; {renderSortIcon('id')}
                              </th>

                              <th onClick={() => handleSort('vendor_name')} scope="col" data-label="User Type">
                                Offered By &nbsp; {renderSortIcon('vendor_name')}
                              </th>

                              <th onClick={() => handleSort('internship_topic')} scope="col" data-label="User Type">
                                Internship Topic &nbsp; {renderSortIcon('internship_topic')}
                              </th>

                              <th onClick={() => handleSort('disciplines')} scope="col" data-label="User Type">
                                Disciplines &nbsp; {renderSortIcon('disciplines')}
                              </th>


                              <th onClick={() => handleSort('internal_seats')} scope="col" data-label="Internal Seats">
                                Internal &nbsp; {renderSortIcon('internal_seats')}
                              </th>

                              <th onClick={() => handleSort('external_seats')} scope="col" data-label="External Seats">
                                External &nbsp; {renderSortIcon('external_seats')}
                              </th>

                              <th onClick={() => handleSort('total_seats')} scope="col" data-label="Total Seats">
                                Total &nbsp; {renderSortIcon('total_seats')}
                              </th>

                              <th onClick={() => handleSort('mode_of_study')} scope="col" data-label="User Type">
                                Mode of Study &nbsp; {renderSortIcon('mode_of_study')}
                              </th>

                              <th scope="col" data-label="Action" width="">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredAndSortedData.length > 0 ? (() => {
                              // Sort logic remains the same
                              const sortedData = [...filteredAndSortedData].sort((a, b) => {
                                const keyA = `${a.discipline_name ?? ''}-${a.college_discipline_type ?? ''}-${a.user_type_name ?? ''}`;
                                const keyB = `${b.discipline_name ?? ''}-${b.college_discipline_type ?? ''}-${b.user_type_name ?? ''}`;
                                return keyA.localeCompare(keyB);
                              });

                              console.log(sortedData);

                              let serialNumber = (currentPage - 1) * 50 + 1;

                              return sortedData.map((item, index) => {
                                return (
                                  <React.Fragment key={`${item.id}-${index}`}>
                                    <tr className="grouped-row">
                                      <td>{serialNumber++}</td>
                                      <td>{item.offered_by_name}</td>
                                      <td>{item.internship_topic}</td>


                                      <td>
                                          {item.disciplines?.length
                                            ? item.disciplines.map(d => d.discipline_name).join(', ')
                                            : '-'}
                                      </td>



                                      <td>{item.internal_seats}</td>
                                      <td>{item.external_seats}</td>
                                      <td>{item.total_seats}</td>

                                      <td>{item.mode_of_study}</td>
                                      <td className="text-center align-middle">
                                        {(item.approve_status === "revert" || item.approve_status === null) ? (
                                          <div className="d-flex justify-content-center gap-2">

                                            <button
                                              className="btn btn-sm btn-outline-success d-flex align-items-center gap-1"
                                              onClick={() => handleForwardUser(item.id)}
                                              title="Forward"
                                            >
                                              <i class="fa fa-share" style={{ size: '10px' }}></i>

                                            </button>

                                            <button
                                              className="btn btn-sm btn-outline-warning d-flex align-items-center gap-1"
                                              onClick={() => handleedit(item.id)}
                                              title="Forward"
                                            >
                                              <i class="fa fa-edit" style={{ size: '10px' }}></i>

                                            </button>

                                            <button
                                              className="btn btn-sm btn-outline-danger d-flex align-items-center gap-1"
                                              onClick={() => handleDeleteUser(item.id)}
                                              title="Delete"
                                            >
                                              <i className="fa fa-trash"></i>

                                            </button>

                                          </div>
                                        ) : (
                                          <span className="badge px-3 py-2 bg-success">
                                            {item.approve_status}
                                          </span>
                                        )}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              });
                            })() : (
                              <tr>
                                <td colSpan="9" className="text-center">No data found</td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {totalPages > 1 && (
                        <nav aria-label="..." style={{ cursor: "pointer" }}>
                          <ul className="pagination justify-content-center">
                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                            </li>
                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                            </li>
                            {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                            {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                              <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                              </li>
                            ))}
                            {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                            <li className={`page-item`}>
                              <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                            </li>

                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                              <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                            </li>
                          </ul>
                        </nav>
                      )}


                      {/*  Delete User */}
                      <div className={`modal fade show ${isDeleteUser ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">

                                <h4 className="text-center pb-2">Are you sure you want to delete?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the deletion.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleDeleteSuccess()}>Delete</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleDeleteCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*  Delete User End */}

                      {/*Forward User */}
                      <div className={`modal fade show ${forwardUserID ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true">
                        <div className="modal-dialog modal-dialog-centered" role="document">
                          <div className="modal-content">
                            <div className="modal-body">
                              <div className="modal-toggle-wrapper">

                                <h4 className="text-center pb-2">Are you sure you want to Forward ?</h4>
                                <p className="text-center">This action cannot be undone. Please confirm if you want to proceed with the Forward.</p>
                                <div className="d-flex justify-content-center mt-3">
                                  <button className="btn btn-danger mx-2" onClick={() => handleforwardSuccess()}>Forward</button>
                                  <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleForwardCancel()}>Cancel</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*Forward User End */}

                      {/* Explore Modal */}
                      <div
                        className={`modal fade ${show ? 'show d-block' : ''}`}
                        style={{
                          backgroundColor: show ? 'rgba(15, 23, 42, 0.8)' : 'transparent',
                          backdropFilter: 'blur(8px)',
                          transition: 'all 0.3s ease-in-out'
                        }}
                      >
                        <div className="modal-dialog modal-xl modal-dialog-centered">
                          <div className="modal-content border-0 overflow-hidden" style={{ borderRadius: '20px', boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)', width: '100%' }}>

                            {/* Custom Header */}
                            <div className="d-flex justify-content-between align-items-center p-4 bg-white border-bottom">
                              <div>
                                <h4 className="mb-0 fw-bold" style={{ color: '#1e293b', letterSpacing: '-0.5px' }}>
                                  Explore Internship Topic
                                </h4>
                                <p className="text-muted small mb-0">Browse and filter available topics by college and discipline.</p>
                              </div>
                              <button
                                onClick={handleClose}
                                className="btn-close shadow-none"
                                style={{ backgroundColor: '#f1f5f9', padding: '1rem', borderRadius: '50%', cursor: 'pointer' }}
                              ></button>
                            </div>

                            <div className="modal-body p-0 d-flex flex-column flex-lg-row" style={{ height: '70vh' }}>

                              {/* Sidebar Filters */}
                              <div className="p-4 border-end bg-light" style={{ width: '100%', maxWidth: '300px' }}>
                                <div className="mb-4">
                                  <label className="form-label small fw-bold text-uppercase text-muted mb-2">College</label>
                                  <Select
                                    className="form text-black"
                                    options={Array.isArray(collegeOptions) ? collegeOptions.map(opt => ({
                                      value: opt.college_id,
                                      label: opt.college_name,
                                    })) : []}
                                    placeholder="All Colleges"

                                    onChange={handleCollegeChange}
                                    value={selectedcollege}
                                  />
                                </div>

                                <div className="mb-4">
                                  <label className="form-label small fw-bold text-uppercase text-muted mb-2">Discipline</label>
                                  <Select
                                    className="form text-black"
                                    options={Array.isArray(disciplineOptions) ? disciplineOptions.map(colopt => ({
                                      value: colopt.id,
                                      label: colopt.discipline_name,
                                    })) : []}
                                    placeholder="All Disciplines"

                                    onChange={handleDisiplinechange}
                                    value={selecteddiscipline}
                                  />
                                </div>

                                <div className="mt-auto p-3 rounded bg-white border text-center">
                                  <div className="h3 fw-bold text-primary mb-0">{Data?.length || 0}</div>
                                  <div className="small text-muted">Topics Available</div>
                                </div>
                              </div>

                              {/* Content Area */}
                              <div className="flex-grow-1 overflow-auto p-4 bg-white">
                                <div className="table-responsive">
                                  <table className="table table-borderless align-middle">
                                    <thead>
                                      <tr style={{ borderBottom: '2px solid #f1f5f9' }}>
                                        <th className="text-muted small fw-bold py-3" width="10%">#</th>
                                        <th className="text-muted small fw-bold py-3">INTERNSHIP TOPIC</th>
                                        <th className="text-muted small fw-bold py-3">INTERNSHIP PROVIDING ORGANISATION</th>
                                        <th className="text-muted small fw-bold py-3">CONTACT DETAILS</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Array.isArray(Data) && Data.length > 0 ? (
                                        Data.map((item, index) => (
                                          <tr key={item.id ?? index} style={{ borderBottom: '1px solid #f8fafc' }}>
                                            <td className="py-3 text-muted">{index + 1}</td>
                                            <td className="py-3 fw-bold text-dark">{item.internship_topic}</td>
                                            <td className="py-3">
                                              <span style={{
                                                backgroundColor: '#e0f2fe',
                                                color: '#0369a1',
                                                padding: '6px 12px',
                                                borderRadius: '6px',
                                                fontSize: '0.85rem',
                                                fontWeight: '500'
                                              }}>
                                                {item.offered_by_name}
                                              </span>
                                            </td>
                                            <td className="py-3">
                                              <div className="d-flex flex-column gap-1">
                                                <div className="small text-muted">{item.vendor_mobileno}</div>
                                                <div className="small text-muted">{item.vendor_email}</div>
                                              </div>
                                            </td>
                                          </tr>
                                        ))
                                      ) : (
                                        <tr>
                                          <td colSpan="3" className="text-center py-5">
                                            <div className="opacity-50">
                                              <i className="bi bi-search d-block fs-1 mb-2"></i>
                                              No results found
                                            </div>
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>

                            {/* Custom Footer */}
                            <div className="p-3 bg-light d-flex justify-content-end gap-2 border-top">
                              <button className="btn btn-outline-secondary border-0 px-4" style={{ borderRadius: '8px', cursor: 'pointer' }} onClick={handleClose}>Dismiss</button>

                            </div>
                          </div>
                        </div>
                      </div>


                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Template>
    </>
  );
}
